const isDev = process.env.NODE_ENV !== "production";

export function logDebug(...args) {
  if (isDev) console.debug(...args);
}

export function logWarn(...args) {
  if (isDev) console.warn(...args);
}
